// extracted by mini-css-extract-plugin
export default {"Box":"DeleteHeaderButtons-module__Box--GOfJ9"};